import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import { ArrowLeft, FileText } from 'lucide-react';

const VoucherTermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="h-8 w-8 text-[#003594]" />
            <h1 className="text-2xl font-bold text-gray-900">Discount Code Terms & Conditions</h1>
          </div>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 mb-6">
              Last updated: February 2026
            </p>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">1. Discount Code Validity</h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>NICE Grading discount codes are valid for 24 months from the date of issue unless otherwise specified.</li>
              <li>Codes must be redeemed before their expiration date.</li>
              <li>Expired codes cannot be redeemed or exchanged for cash.</li>
            </ul>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">2. Redemption</h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Discount codes can only be redeemed at nicegrading.com during the submission process.</li>
              <li>Each code can only be used once.</li>
              <li>Codes are non-transferable after redemption.</li>
              <li>Card-based discounts provide free grading for the specified number of cards at your applicable pricing tier.</li>
              <li>Dollar-based discounts provide a fixed dollar discount off your submission total.</li>
            </ul>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">3. Restrictions</h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Some discount codes may have minimum card requirements or other restrictions.</li>
              <li>Codes cannot be combined with other promotions unless explicitly stated.</li>
              <li>Discount codes have no cash value and cannot be exchanged for cash.</li>
              <li>If a discount value exceeds the order total, no credit or refund will be issued for the difference.</li>
            </ul>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">4. Lost or Stolen Codes</h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>NICE Grading is not responsible for lost, stolen, or damaged discount codes.</li>
              <li>Protect your discount code as you would cash.</li>
            </ul>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">5. Modifications</h2>
            <p className="text-gray-600">
              NICE Grading reserves the right to modify, suspend, or terminate the discount code program 
              at any time without prior notice. We may also modify these terms at our discretion.
            </p>
            
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-3">6. Contact</h2>
            <p className="text-gray-600">
              For questions about discount codes or these terms, please contact us at{' '}
              <a href="mailto:support@nicegrading.com" className="text-[#003594] hover:underline">
                support@nicegrading.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoucherTermsPage;
